"use client";

import { useState } from "react";
import type { Faq } from "./faqData";
import { Eyebrow } from "./ui/Eyebrow";

function FaqItem({ q, a }: Faq) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-line">
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between gap-4 py-5 text-left"
        aria-expanded={open}
      >
        <span className="font-display text-lg font-semibold">{q}</span>
        <span
          className={`grid h-7 w-7 shrink-0 place-items-center rounded-full border border-line text-lg transition-transform ${
            open ? "rotate-45 bg-gold text-paper-2" : "text-ink-soft"
          }`}
        >
          +
        </span>
      </button>
      <div
        className="grid transition-all duration-300 ease-out"
        style={{ gridTemplateRows: open ? "1fr" : "0fr" }}
      >
        <div className="overflow-hidden">
          <p className="pr-10 pb-5 text-[15px] leading-relaxed text-ink-soft">{a}</p>
        </div>
      </div>
    </div>
  );
}

export function FaqAccordion({ sections }: { sections: { heading: string; items: Faq[] }[] }) {
  return (
    <div className="space-y-12">
      {sections.map((section) => (
        <div key={section.heading}>
          <Eyebrow as="h2">{section.heading}</Eyebrow>
          <div className="mt-3">
            {section.items.map((item) => (
              <FaqItem key={item.q} {...item} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
